export const IMAGES = {
  psrLogoUrlPNG: new URL('/images/PSR.png', import.meta.url).toString(),
  psrLogoUrlSVG: new URL('/images/PSR.svg', import.meta.url).toString(),
  logoUrlPNG: new URL(
    '/images/lloyds-logo-small.png',
    import.meta.url
  ).toString(),
  phonIconUrl: new URL('/images/phone.png', import.meta.url).toString(),
  mouseIconUrl: new URL('/images/mouse.png', import.meta.url).toString(),
  successIconUrl: new URL('/images/success.png', import.meta.url).toString(),
  clockIconUrl: new URL('/images/clock.png', import.meta.url).toString(),
};
